import { useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { RootState } from "../store/reducers";
import { useSelector } from "react-redux";

interface WelcomeNameProps {
  isImpersonating?: boolean;
  impersonatedUserEmail?: string | null;
}

const WelcomeName = ({
  isImpersonating,
  impersonatedUserEmail,
}: WelcomeNameProps) => {
  const { instance } = useMsal();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  var account = instance.getActiveAccount();

  const displayName = account?.idTokenClaims?.given_name
    ? `${account?.idTokenClaims?.given_name} ${
        account?.idTokenClaims?.family_name ?? ""
      }`
    : account?.name ?? account?.username;

  if (!account) {
    return null;
  }

  return (
    <Typography
      variant="body2"
      noWrap
      sx={{
        display: { xs: "none", sm: "block" },
        maxWidth: 200,
        textOverflow: "ellipsis",
        overflow: "hidden",
      }}
    >
      {isImpersonating && impersonatedUserEmail
        ? `${impersonatedUserEmail}`
        : displayName}
    </Typography>
  );
};

export default WelcomeName;
